import Image from 'next/image';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { HelpPost } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/help-post.type';

interface HelpPostCardProps {
  post: HelpPost;
}

export const HelpPostCard = ({ post }: HelpPostCardProps) => {
  return (
    <Link
      prefetch={false}
      href={`/preciso-de-ajuda/${post.slug}/`}
      className="group h-full"
      data-testid={`${post.slug}${DataTestIdEnum.FAQ_HELP_POST_LINK}`}
    >
      <Card
        className="flex flex-col px-0 py-0 hover:bg-green-50 h-full overflow-hidden"
        data-testid={`${post.slug}${DataTestIdEnum.FAQ_HELP_POST_CARD}`}
      >
        {post.coverImage
          ? (
              <Image
                src={post.coverImage}
                alt={post.coverImageAlt}
                width={800}
                height={448}
                className="object-cover w-full h-56 rounded-t-xl"
              />
            )
          : (
              <div
                aria-hidden="true"
                className="w-full h-56 rounded-t-xl bg-green-50"
              />
            )}
        <div className="flex flex-col gap-2 p-6 flex-1">
          <Typography
            variant={TypographyVariant.BODY_STRONG}
            as="p"
            className="font-bold line-clamp-2"
            data-testid={`${post.slug}${DataTestIdEnum.FAQ_HELP_POST_TITLE}`}
          >
            {post.title}
          </Typography>
          <Typography
            variant={TypographyVariant.BODY_TEXT}
            as="p"
            className="line-clamp-3"
          >
            {post.description}
          </Typography>
          <div className="mt-auto pt-2 flex items-center gap-2 text-green-500 font-semibold">
            <span>Saiba mais</span>
            <Icon
              icon={faAngleRight}
              className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300"
            />
          </div>
        </div>
      </Card>
    </Link>
  );
};
